(function HotelProcessor($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('HotelBooking/processor', function onload() {
			processNextAction();

			// $('.econnect-loader').dblclick(function swapLoader() {
			// 	$(this).attr('src', Adzuki.base_uri + '/adzuki/images/econnect-loader-homer.gif');
			// });
		});
	});

	function processNextAction()
	{
		var $processor = $('div.processor-content'),
		    url        = Adzuki.base_uri + '/HotelBooking/' + $processor.data('complete-action');

		Adzuki.Ajax.get('/HotelBooking/' + $processor.data('load-action'))
		.then(function success(data) {
			if (data.return_value === 'complete') {
				if (data.reservation_id && data.component_id) {
					url += '/'+data.reservation_id+'/'+data.component_id;
				}

				if (data.package_id) {
					url += '/'+data.package_id;
				}

				window.location.href = url;
			}
		});
	}

}(jQuery, window.Adzuki || {}));